<template>
<span>
    <img v-if="src"
         :src="src"
         class="odr-avatar"
         :class="{
             'odr-avatar_large': size === 'l',
             'odr-avatar_medium': size === 'm',
             'odr-avatar_small': size === 's',
             'odr-avatar_xsmall': size === 'xs',
         }"
         :style="style"/>
    <svg v-else
         class="odr-avatar"
         :class="{
             'odr-avatar_large': size === 'l',
             'odr-avatar_medium': size === 'm',
             'odr-avatar_small': size === 's',
             'odr-avatar_xsmall': size === 'xs',
         }"
         :style="style"
         width="80"
         height="80"
         viewBox="0 0 80 80"
         xmlns="http://www.w3.org/2000/svg">
        <title>no-avatar</title>
        <g fill="none" fill-rule="evenodd">
            <circle fill="#D8D8D8"
                    cx="40"
                    cy="40"
                    r="40"/>
            <path d="M40 37c4.95 0 9-4.05 9-9s-4.05-9-9-9-9 4.05-9 9 4.05 9 9 9zm0 4.5c-6.075 0-18 2.925-18 9V55h36v-4.5c0-6.075-11.925-9-18-9z" fill="#FFF"/>
        </g>
    </svg>
</span>
</template>

<script>
import '../styles/avatar.scss'

export default {
    props: {
        size: {
            type: String,
            validator: v => (v === 'l' || v === 'm' || v === 's' || v === 'xs'),
            _descr: 'size: l|m|s|xs',
        },
        exact: {
            type: String,
        },
        src: {
            type: String,
            _descr: 'src for image',
        },
    },
    computed: {
        style () {
            return this.exact ? `width: ${this.exact} !important; height: ${this.exact} !important` : null
        },
    },
}
</script>
